/**
 * Parley Green theme JS — progressive enhancement only.
 * Everything in the theme works without JavaScript; this file adds:
 * 1. Mobile navigation drawer (dialog open/close)
 * 2. Quantity steppers (+/- buttons around a number input)
 * 3. Product gallery active-thumbnail state
 * 4. Header disclosure menus (mega panel + dropdown) with hover intent
 */
(function () {
  'use strict';

  document.documentElement.classList.add('js');

  /* 4. Header disclosure menus ------------------------------------------ */
  /* Hover intent per NN/g + Baymard: ~300ms before opening on hover,
     ~350ms grace before closing, instant switch while a panel is open.
     Click/keyboard follow the WAI-ARIA disclosure navigation pattern. */
  (function initHeaderNav() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-nav-item]'));
    if (!items.length) return;

    var OPEN_DELAY = 300;
    var CLOSE_DELAY = 350;
    var hoverCapable = window.matchMedia('(hover: hover)').matches;
    var openItem = null;
    var openTimer = null;
    var closeTimer = null;

    function setState(item, open) {
      var trigger = item.querySelector('[data-nav-trigger]');
      if (open) {
        item.setAttribute('data-open', '');
      } else {
        item.removeAttribute('data-open');
      }
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openPanel(item) {
      if (openItem === item) return;
      if (openItem) setState(openItem, false);
      setState(item, true);
      openItem = item;
    }

    function closePanel() {
      if (!openItem) return;
      setState(openItem, false);
      openItem = null;
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-nav-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        if (openItem === item) {
          closePanel();
        } else {
          openPanel(item);
        }
      });

      if (hoverCapable) {
        item.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(function () {
            openPanel(item);
          }, openItem ? 60 : OPEN_DELAY);
        });

        item.addEventListener('pointerleave', function (event) {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
          closeTimer = setTimeout(closePanel, CLOSE_DELAY);
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openItem) return;
      var trigger = openItem.querySelector('[data-nav-trigger]');
      closePanel();
      if (trigger) trigger.focus();
    });

    document.addEventListener('click', function (event) {
      if (openItem && !event.target.closest('[data-nav-item]')) closePanel();
    });

    /* Close when tab focus leaves the open item entirely. */
    document.addEventListener('focusin', function (event) {
      if (openItem && !openItem.contains(event.target)) closePanel();
    });
  })();

  /* 1. Mobile nav drawer ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-drawer-open]');
    if (openTrigger) {
      var drawer = document.getElementById(openTrigger.getAttribute('data-drawer-open'));
      if (drawer && typeof drawer.showModal === 'function') {
        drawer.showModal();
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-drawer-close]');
    if (closeTrigger) {
      var openDrawer = closeTrigger.closest('dialog');
      if (openDrawer) openDrawer.close();
      return;
    }

    /* Close the drawer when clicking the backdrop (outside the panel). */
    var dialog = event.target.closest('dialog[data-drawer]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });

  /* 2. Quantity steppers ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;

    var wrapper = button.closest('[data-qty-input]');
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;

    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var value = parseInt(input.value, 10) || min;
    var delta = button.getAttribute('data-qty-change') === 'up' ? step : -step;

    input.value = Math.max(min, value + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* 3. Product gallery: highlight the thumbnail of the slide in view ---- */
  function initGallery(gallery) {
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!thumbs.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          thumbs.forEach(function (thumb) {
            var isActive = thumb.getAttribute('href') === '#' + entry.target.id;
            thumb.classList.toggle('is-active', isActive);
          });
        });
      },
      { root: gallery, threshold: 0.6 }
    );

    gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
      observer.observe(slide);
    });
  }

  document.querySelectorAll('[data-gallery]').forEach(initGallery);
})();
